import { ArrowType, LineType } from '@ardoq/api-types';
import { colors } from '@ardoq/design-tokens';

export const componentTypeDefaultShape = 'predefinedProcess';

/** The stored shape meaning "no shape chosen"; it has no sprite behind it. */
export const NO_SHAPE = 'none';

/**
 * The shape to draw for a stored shape value. `NO_SHAPE` is a real stored value
 * with no sprite behind it, so drawing it yields an empty swatch and an
 * unresolved-image error; every renderer substitutes the default shape instead.
 */
export const toDrawableShapeName = (
  shapeName: string | null | undefined
): string =>
  !shapeName || shapeName === NO_SHAPE ? componentTypeDefaultShape : shapeName;

export const referenceTypeDefaultColor = 'black';
export const referenceTypeDefaultLineType = LineType.DASHED;
export const referenceTypeDefaultLineBeginning = ArrowType.NONE;
export const referenceTypeDefaultLineEnding = ArrowType.BOTH;

export const defaultComponentType = {
  _version: 1,
  removable: true,
  name: '',
  color: colors.blue600,
  icon: null,
  image: null,
  shape: componentTypeDefaultShape,
  standard: null,
  description: null,
  level: 1,
  parent: null,
};

export const defaultReferenceType = {
  _version: 1,
  removable: true,
  name: '',
  color: referenceTypeDefaultColor,
  line: referenceTypeDefaultLineType,
  lineBeginning: referenceTypeDefaultLineBeginning,
  lineEnding: referenceTypeDefaultLineEnding,
  hasCardinality: false,
  description: null,
};
